import { RightPage } from "@/UDTreat/right/RightPage"
import MyAccordion from "./MyAccordion"

import { useAppSelector } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import { EArchType, wasmModule } from "@/gluelayer"
import { useEffect, useMemo, useState } from "react"

import { isRetainerArch } from "@/shared/utils/tools/caseUtils"
import "./index.scss"

export const UDSetup = (props) => {
  const [disabledGMModel, setDisabledGMModel] = useState<boolean>(false)
  const [disabledArchForm, setDisabledArchForm] = useState<boolean>(false)
  const [disabledIPR, setDisabledIPR] = useState<boolean>(false)
  const { curArch: curArchFromStore, singleArchBool } = useAppSelector(
    (state: RootState) => state.udTreatService,
  )

  const curArch = useMemo(() => {
    const hasUpper = wasmModule.getArchModel(EArchType.UpArch)
    const hasLower = wasmModule.getArchModel(EArchType.LowArch)

    if (singleArchBool) {
      if (hasUpper) {
        return "up"
      }
      if (hasLower) {
        return "low"
      }
    } else {
      return curArchFromStore
    }
  }, [curArchFromStore])

  useEffect(() => {
    const upIsRetainer = isRetainerArch(EArchType.UpArch)
    const lowIsRetainer = isRetainerArch(EArchType.LowArch)

    // console.log("curArch=============", curArch)
    // console.log("lowIsRetainer=============", lowIsRetainer)
    // console.log("upIsRetainer=============", upIsRetainer)

    if (upIsRetainer || lowIsRetainer) {
      setDisabledGMModel(true)
    } else {
      setDisabledGMModel(false)
    }

    if (curArch === "all") {
      if (upIsRetainer && lowIsRetainer) {
        setDisabledArchForm(true)
        setDisabledIPR(true)
      } else {
        setDisabledArchForm(false)
        setDisabledIPR(false)
      }
    }

    if (curArch === "up") {
      if (upIsRetainer) {
        setDisabledArchForm(true)
        setDisabledIPR(true)
      } else {
        setDisabledArchForm(false)
        setDisabledIPR(false)
      }
    }

    if (curArch === "low") {
      if (lowIsRetainer) {
        setDisabledArchForm(true)
        setDisabledIPR(true)
      } else {
        setDisabledArchForm(false)
        setDisabledIPR(false)
      }
    }
  }, [curArch])

  return (
    <RightPage
      title="Setup"
      onClose={props.onClose}
      className="ud-setup-model"
      bodyClassName="ud-setup-model-body"
      content={
        <div className="ud-setup-model-body-content">
          <MyAccordion
            curArch={curArch}
            disabledGMModel={disabledGMModel}
            disabledArchForm={disabledArchForm}
            disabledIPR={disabledIPR}
          />
        </div>
      }
    />
  )
}
